import React from "react";
import styled from "styled-components";
import KpiRecommendationTile from "./KpiRecommendationTile";
import KpiErrorsTile from "./KpiErrorsTile";
import KpiIndexabilityTile from "./KpiIndexabilityTile";
import KpiPageCrawledTile from "./KpiPageCrawledTile";

const Row = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 16px;
    @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
    @media (max-width: 600px) { grid-template-columns: 1fr; gap: 10px; }
`;

export default function KpiSection({ startDate, endDate }) {
    return (
        <Row>
            <KpiPageCrawledTile startDate={startDate} endDate={endDate} />
            <KpiErrorsTile startDate={startDate} endDate={endDate} />
            <KpiIndexabilityTile startDate={startDate} endDate={endDate} />
            <KpiRecommendationTile startDate={startDate} endDate={endDate} />
        </Row>
    );
}
